module.exports = __webpack_public_path__ + "img/f1.d1ac313f.jpg";